(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const configElement = root.querySelector('[data-art-config]');
    if (!configElement) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(configElement.textContent);
    const form = root.querySelector('form');
    const select = root.querySelector('[data-art-service]');
    const idea = root.querySelector('[data-art-idea]');
    const link = root.querySelector('[data-art-link]');
    const files = [...root.querySelectorAll('[data-art-file]')];
    const sizes = [...root.querySelectorAll('[data-art-size]')];
    const embroidery = root.querySelector('[data-art-embroidery]');
    const error = root.querySelector('[data-art-error]');
    const button = root.querySelector('[data-art-submit]');
    let submitting = false;
    const showError = (message) => {
      error.textContent = message;
      error.hidden = !message;
    };
    function updateSelection() {
      const variant = config.variants.find(v => v.id === select.value);
      if (!variant) return;
      for (const key of ['name', 'scope', 'files', 'timing', 'price']) root.querySelector(`[data-art-${key}]`).textContent = variant[key];
      root.querySelector('[data-art-scope-value]').value = variant.scope;
      root.querySelector('[data-art-files-value]').value = variant.files;
      root.querySelector('[data-art-mobile-scope]').textContent = `${variant.scope} ${variant.files}`;
      const isEmbroidery = variant.sku.includes('-DIGI-');
      embroidery.hidden = !isEmbroidery;
      embroidery.disabled = !isEmbroidery;
      embroidery.querySelectorAll('[data-art-embroidery-required]').forEach(el => el.required = isEmbroidery);
      sizes.forEach(size => size.required = isEmbroidery || variant.sku === 'RBS-ART-PREP');
      root.querySelector('[data-art-size-required]').hidden = !sizes[0].required;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(null, '', url);
    }
    const incoming = new URLSearchParams(window.location.search).get('variant');
    if (config.variants.some(v => v.id === incoming)) select.value = incoming;
    updateSelection();
    select.addEventListener('change', updateSelection);
    root.querySelectorAll('[data-art-choose]').forEach(el => el.addEventListener('click', () => {
      select.value = el.dataset.artChoose;
      updateSelection();
      select.scrollIntoView({block:'center', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      select.focus({preventScroll:true});
    }));
    const validExtensions = /\.(png|jpe?g|pdf|svg|ai|eps)$/i;
    const validFile = file => validExtensions.test(file.name) && file.size > 0 && file.size <= 10 * 1024 * 1024;
    files.forEach(input => input.addEventListener('change', () => {
      input.setCustomValidity('');
      if (input.files[0] && !validFile(input.files[0])) {
        input.setCustomValidity(config.invalidFile);
        input.reportValidity();
      } else showError('');
    }));
    idea.addEventListener('input', () => {idea.setCustomValidity(''); showError('');});
    link.addEventListener('input', () => {idea.setCustomValidity(''); showError('');});
    files.forEach(input => input.addEventListener('change', () => idea.setCustomValidity('')));
    form.addEventListener('submit', event => {
      if (submitting) {event.preventDefault(); return;}
      const hasFiles = files.some(input => input.files.length);
      if (!hasFiles && !idea.value.trim() && !link.value.trim()) {
        event.preventDefault();
        showError(config.missingBrief);
        idea.setCustomValidity(config.missingBrief);
        idea.focus();
        idea.reportValidity();
        return;
      }
      for (const input of files) {
        if (input.files[0] && !validFile(input.files[0])) {event.preventDefault(); showError(config.invalidFile); input.focus(); return;}
      }
      embroidery.querySelectorAll('[data-art-embroidery-required]').forEach(input => { input.value = input.value.trim(); });
      if (!form.reportValidity()) {event.preventDefault(); return;}
      showError('');
      submitting = true;
      button.disabled = true;
      button.textContent = config.uploading;
      form.setAttribute('aria-busy', 'true');
    });
    button.disabled = false;
    window.addEventListener('pageshow', () => {
      submitting = false;
      button.disabled = false;
      button.textContent = config.addToCart;
      form.removeAttribute('aria-busy');
    });
  }
  document.querySelectorAll('[data-rbs-artwork]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rbs-artwork]').forEach(init));
})();
